module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Global Tracking page")])], 1), _vm._v(" "), _c('b-card', [_c('md-layout', {
    staticClass: "align-items-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    staticClass: "ml-3",
    attrs: {
      "list": _vm.bookingNoList,
      "id": "clientNamenew",
      "option-value": "id",
      "option-text": "request_key",
      "placeholder": "Select Booking No"
    },
    model: {
      value: (_vm.bookingNoFilter),
      callback: function($$v) {
        _vm.bookingNoFilter = $$v
      },
      expression: "bookingNoFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    staticClass: "ml-3",
    attrs: {
      "list": _vm.blMaster,
      "id": "clientNamenew",
      "option-value": "id",
      "option-text": "name",
      "placeholder": "Select Master BL No"
    },
    model: {
      value: (_vm.ContainerFilter),
      callback: function($$v) {
        _vm.ContainerFilter = $$v
      },
      expression: "ContainerFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-button', {
    staticClass: "ml-auto",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.globalTracking
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [(_vm.containerShippmentDetails.length > 0) ? _c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.containerShippmentDetails,
      "fields": _vm.TrackingFields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "jobType",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "dlv_loc",
      fn: function(dlv) {
        return [(dlv.item.dlv_loc) ? _c('span', [_vm._v(_vm._s(dlv.item.dlv_loc.name))]) : _vm._e()]
      }
    }, {
      key: "origin_loc",
      fn: function(org) {
        return [(org.item.origin_loc) ? _c('span', [_vm._v(_vm._s(org.item.origin_loc.name))]) : _vm._e()]
      }
    }, {
      key: "pod_loc",
      fn: function(pod) {
        return [(pod.item.pod_loc) ? _c('span', [_vm._v(_vm._s(pod.item.pod_loc.name))]) : _vm._e()]
      }
    }, {
      key: "pol_loc",
      fn: function(pol) {
        return [(pol.item.pol_loc) ? _c('span', {
          directives: [{
            name: "b-toggle",
            rawName: "v-b-toggle.collapse1",
            modifiers: {
              "collapse1": true
            }
          }]
        }, [_vm._v(_vm._s(pol.item.pol_loc.name))]) : _vm._e(), _vm._v(" "), _c('b-collapse', {
          staticClass: "mt-2",
          attrs: {
            "id": "collapse1"
          }
        }, [_c('b-card', [_vm._v("I am collapsible content A!")])], 1)]
      }
    }, {
      key: "show_details",
      fn: function(row4) {
        return [_c('b-form-checkbox', {
          on: {
            "change": row4.toggleDetails
          },
          model: {
            value: (row4.detailsShowing),
            callback: function($$v) {
              _vm.$set(row4, "detailsShowing", $$v)
            },
            expression: "row4.detailsShowing"
          }
        })]
      }
    }, {
      key: "row-details",
      fn: function(row4) {
        return [_c('b-card', {
          staticStyle: {
            "background": "whiteSmoke"
          }
        }, [_c('b-row', [_c('b-col', {
          attrs: {
            "md": "4"
          }
        }, [_c('b', [_vm._v("Empty Pickup Location : ")]), _vm._v(" "), (row4.item.empty_pickup_loc) ? _c('span', [_vm._v(_vm._s(row4.item.empty_pickup_loc.name) + " / " + _vm._s(row4.item.empty_pickup_actual))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (row4.item.pol_vsldeparture_planned_initial) ? _c('span', [_c('b', [_vm._v("SOB Tentative Date : ")]), _vm._v(_vm._s(row4.item.pol_vsldeparture_planned_initial))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (row4.item.pol_vsldeparture_actual) ? _c('span', [_c('b', [_vm._v("SOB Actual Date : ")]), _vm._v(_vm._s(row4.item.pol_vsldeparture_actual))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (row4.item.pol_arrival_planned_initial || row4.item.pol_arrival_actual) ? _c('div', [_c('b', [_vm._v("POL Arrival Planned Initial/Actual : ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(row4.item.pol_arrival_planned_initial ? row4.item.pol_arrival_planned_initial : "NA") + " / " + _vm._s(row4.item.pol_arrival_actual ? row4.item.pol_arrival_actual : "NA") + " ")])]) : _vm._e(), _vm._v(" "), (row4.item.pol_vsldeparture_planned_initial || row4.item.pol_vsldeparture_actual) ? _c('div', [_c('b', [_vm._v("POL VSL Departure Initial/Actual : ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(row4.item.pol_vsldeparture_planned_initial ? row4.item.pol_vsldeparture_planned_initial : "NA") + " / " + _vm._s(row4.item.pol_vsldeparture_actual ? row4.item.pol_vsldeparture_actual : "NA") + " ")])]) : _vm._e(), _vm._v(" "), (row4.item.pod_vslarrival_planned_initial || row4.item.pod_vslarrival_actual) ? _c('div', [_c('b', [_vm._v("POD VSL Arrival Initial/Actual : ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(row4.item.pod_vslarrival_planned_initial ? row4.item.pod_vslarrival_planned_initial : "NA") + " / " + _vm._s(row4.item.pod_vslarrival_actual ? row4.item.pod_vslarrival_actual : "NA") + " ")])]) : _vm._e(), _vm._v(" "), (row4.item.pod_departure_planned_initial || row4.item.pod_departure_actual) ? _c('div', [_c('b', [_vm._v("POD VSL Departure Planned Initial/Actual : ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(row4.item.pod_departure_planned_initial ? row4.item.pod_departure_planned_initial : 'NA') + " / " + _vm._s(row4.item.pod_departure_actual ? row4.item.pod_departure_actual : "NA") + " ")])]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v("Leg1 Vessel / Voyage")]), _vm._v(" "), (row4.item.leg1_vessel) ? _c('span', [_vm._v(_vm._s(row4.item.leg1_vessel.name) + " / " + _vm._s(row4.item.leg1_voyage) + " ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (row4.item.leg2_vessel) ? _c('div', [_c('b', [_vm._v("Leg2 Vessel / Voyage")]), _vm._v(" "), (row4.item.leg2_vessel) ? _c('span', [_vm._v(_vm._s(row4.item.leg2_vessel.name) + " / " + _vm._s(row4.item.leg2_voyage) + " ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (row4.item.leg3_vessel) ? _c('div', [_c('b', [_vm._v("Leg3 Vessel / Voyage")]), _vm._v(" "), (row4.item.leg3_vessel) ? _c('span', [_vm._v(_vm._s(row4.item.leg3_vessel.name) + " / " + _vm._s(row4.item.leg3_voyage) + " ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (row4.item.leg4_vessel) ? _c('div', [_c('b', [_vm._v("Leg4 Vessel / Voyage")]), _vm._v(" "), (row4.item.leg4_vessel) ? _c('span', [_vm._v(_vm._s(row4.item.leg4_vessel.name) + " / " + _vm._s(row4.item.leg4_voyage) + " ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (row4.item.leg5_vessel) ? _c('div', [_c('b', [_vm._v("Leg5 Vessel / Voyage")]), _vm._v(" "), (row4.item.leg5_vessel) ? _c('span', [_vm._v(_vm._s(row4.item.leg5_vessel.name) + " / " + _vm._s(row4.item.leg5_voyage) + " ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (row4.item.tsp1_loc) ? _c('b-col', {
          attrs: {
            "md": "4"
          }
        }, [_c('b', [_vm._v("tsp1 location : ")]), _vm._v(" "), (row4.item.tsp1_loc) ? _c('span', [_vm._v(_vm._s(row4.item.tsp1_loc.name) + " ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("tsp1 vsl arrival planned initial/actual : ")]), _vm._v(" "), (row4.item.tsp1_vslarrival_planned_initial || row4.item.tsp1_vslarrival_actual) ? _c('span', [_vm._v("\n                      " + _vm._s(row4.item.tsp1_vslarrival_planned_initial + "/" + row4.item.tsp1_vslarrival_actual) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("tsp1 vsl departure planned initial/actual")]), _vm._v(" "), (row4.item.tsp1_vsldeparture_planned_initial || row4.item.tsp1_vsldeparture_actual) ? _c('span', [_vm._v("\n                      " + _vm._s(row4.item.tsp1_vsldeparture_planned_initial + "/" + row4.item.tsp1_vsldeparture_actual) + "\n                    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (row4.item.tsp2_loc) ? _c('b-col', {
          attrs: {
            "md": "4"
          }
        }, [_c('b', [_vm._v("tsp2 location : ")]), _vm._v(" "), (row4.item.tsp2_loc) ? _c('span', [_vm._v(_vm._s(row4.item.tsp2_loc.name) + " ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("tsp2 vsl arrival planned initial/Actual : ")]), _vm._v(" "), (row4.item.tsp2_vslarrival_planned_initial || row4.item.tsp2_vslarrival_actual) ? _c('span', [_vm._v("\n                      " + _vm._s(row4.item.tsp2_vslarrival_planned_initial + "/" + row4.item.tsp2_vslarrival_actual) + " ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("tsp2 vsl departure planned initial/actual")]), _vm._v(" "), (row4.item.tsp2_vsldeparture_planned_initial || row4.item.tsp2_vsldeparture_actual) ? _c('span', [_vm._v("\n                      " + _vm._s(row4.item.tsp2_vsldeparture_planned_initial + "/" + row4.item.tsp2_vsldeparture_actual) + "\n                    ")]) : _vm._e()]) : _vm._e()], 1)], 1)]
      }
    }, {
      key: "mainSalesSeries",
      fn: function(row1) {
        return [_c('b', [_vm._v(_vm._s(row1.item.jobNo))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row1.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), _c('br')]
      }
    }, {
      key: "TPTClient",
      fn: function(row11) {
        return [(
          row11.item.clientType == '3' &&
          row11.item.transportType == 'Export'
        ) ? _c('b', [_vm._v("\n                  Client Name : " + _vm._s(row11.item.clientName) + "\n                  "), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.clientType == '3') ? _c('b', [_vm._v("\n                  Overseas Agent : " + _vm._s(row11.item.clientName) + "\n                  "), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.clientType != '3') ? _c('b', [_vm._v("\n                  " + _vm._s(row11.item.clientName) + "\n                  "), _c('br')]) : _vm._e()]
      }
    }, {
      key: "ffInvoiceClosed",
      fn: function(row2) {
        return [(row2.item.jobType.split(',').includes('FF')) ? _c('span', [_vm._v("FF :-\n                  " + _vm._s(row2.item.ffInvoiceClosed == "1" ?
          "Received" :
          "Not-Received")), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.jobType.split(',').includes('CC')) ? _c('span', [_vm._v("CC :-\n                  " + _vm._s(row2.item.ccInvoiceClosed == "1" ?
          "Received" :
          "Not-Received")), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.jobType.split(',').includes('TPT')) ? _c('span', [_vm._v("TPT :-\n                  " + _vm._s(row2.item.tptInvoiceClosed == "1" ?
          "Received" :
          "Not-Received"))]) : _vm._e()]
      }
    }, {
      key: "billingSeries",
      fn: function(row1000) {
        return [(row1000.item.BillingSeries) ? _c('div', _vm._l((row1000.item.BillingSeries.split(',')), function(item3, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item3 == "" ? "-------" : item3) + "\n                      ")])], 1)])
        })) : _c('span', [_vm._v("-----------")]), _vm._v(" "), _c('b-button', {
          attrs: {
            "variant": "outline-primary",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.proceedBilling(
                row1000.item.allModuleId,
                row1000.item.newContainerFlow,
                row1000.item.isConsolidation,
                row1000.item.mainSalesSeries
              )
            }
          }
        }, [_vm._v(_vm._s("Show Invoice"))])]
      }
    }])
  })], 1) : _vm._e()]), _vm._v(" "), (false) ? _c('div', [_c('h5', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n        ")])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-close-conf",
    attrs: {
      "id": "modal-close-conf",
      "title": "Submit Your Reason",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('h3', [_vm._v("Confirmation")]), _vm._v(" "), (_vm.incompleteJobBill) ? _c('h4', {
    staticClass: "error"
  }, [_c('small', [_vm._v("Invoice Not added for ")]), _vm._v(" " + _vm._s(_vm.incompleteJobBill) + "  "), _c('small', [_vm._v(" Please Kindly Check..!")])]) : _vm._e(), _vm._v(" "), _c('form', {
    ref: "form"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Reason for closing assignment billing",
      "label-for": "name-input",
      "invalid-feedback": "Name is required"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.closingReason),
      callback: function($$v) {
        _vm.closingReason = $$v
      },
      expression: "closingReason"
    }
  })], 1)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.closingReason ? false : true,
      "variant": "success"
    },
    on: {
      "click": _vm.closeBillOk
    }
  }, [_vm._v(" Confirm & Close Billing")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeModalConfirm
    }
  }, [_vm._v(" Cancel")])], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopApprove",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopReject",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopDelete",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopTally",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.closeBillOk
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "notFound",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea8a36dc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/globalTracking.vue
// module id = 2900
// module chunks = 0